module.exports = __webpack_public_path__ + "img/02logo-wss2021.9b1ea2c7.png";